/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useConfig } from 'app/hooks';
import CompetitionDetailData from 'app/modules/cinemaRent/components/Competition/CompetitionDetail';
import PropTypes from 'prop-types';
import { Loader } from 'app/components';
import { BonusInfoWrapper } from './styles';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  formOutput: PropTypes.array,
  film: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  // pdf_content: PropTypes.string.isRequired,
  fetchCompetitionContent: PropTypes.func.isRequired,
  fetchSliderContent: PropTypes.func.isRequired,
  fetchCompetitionDetailById: PropTypes.func.isRequired,
  sendFormData: PropTypes.func.isRequired,
  // fetchPDFContent: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool,
  legalInfo: PropTypes.arrayOf(
    PropTypes.shape({
      doc: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  ).isRequired,
  competitionEvents: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  getCompetitionEvents: PropTypes.func.isRequired,
  location: PropTypes.string.isRequired
};

const defaultProps = {
  formOutput: [],
  film: [],
  isSubmitted: false,
  competitionEvents: []
};

const CompetitionDetail = ({
  match,
  isLoggedIn,
  fetchCompetitionContent,
  fetchSliderContent,
  sendFormData,
  formOutput,
  fetchCompetitionDetailById,
  isSubmitted,
  legalInfo,
  film,
  competitionEvents,
  getCompetitionEvents,
  location
}) => {
  const [t] = useTranslation();
  const { id } = match.params;
  const commpetition = useSelector(state => state.information.competitions);
  const commpetitionInfo = commpetition?.find(item => item?.id === +id);
  const [formData, updateFormData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [legalInfoList, setLegalInfoList] = useState([]);
  const {
    media: { docsPrefix }
  } = useConfig();

  useEffect(() => {
    if (legalInfo?.length) {
      const list = legalInfo.filter(item => [3].some(value => value === +item.docType));

      setLegalInfoList(list);
    }
  }, [legalInfo]);

  useEffect(() => {
    if (commpetitionInfo?.id) {
      fetchCompetitionDetailById({ id: commpetitionInfo?.id });
      for (let i = 0; i < commpetitionInfo?.HOFilmCodes?.length; i += 1) {
        fetchSliderContent({
          id: commpetitionInfo?.HOFilmCodes[i]?.HOFilmCode
        });
      }
    }
  }, [commpetitionInfo]);

  useEffect(() => {
    if (formData?.length !== 0) {
      if (formData.competitionID !== 0 && formData.competitionID !== undefined) {
        sendFormData(formData);
      }
    }
  }, [formData]);

  useEffect(() => {
    fetchCompetitionContent();
    getCompetitionEvents();
    setTimeout(() => {
      setLoader(false);
    }, 4000);
  }, []);

  return (
    <BonusInfoWrapper>
      {loader ? (
        <Loader />
      ) : (
        commpetitionInfo?.id && (
          <>
            <h1 className="bonus-info__title">{t('common.competitions_detail')}</h1>
            <div className="container">
              <CompetitionDetailData
                film={film}
                isLoggedIn={isLoggedIn}
                info={commpetitionInfo}
                formData={formData}
                updateFormData={updateFormData}
                formOutput={formOutput}
                isSubmitted={isSubmitted}
                pdfContent={docsPrefix(legalInfoList[0]?.doc)}
                eventList={competitionEvents}
                location={location}
              />
            </div>
          </>
        )
      )}
    </BonusInfoWrapper>
  );
};

CompetitionDetail.propTypes = propTypes;
CompetitionDetail.defaultProps = defaultProps;

export default CompetitionDetail;
